import { createApp } from 'vue';
import App from './App.vue';

const app = createApp(App);
import "@grapecity/spread-sheets-print";
import "@grapecity/spread-sheets-shapes";
import "@grapecity/spread-sheets-pivot-addon";
import "@grapecity/spread-sheets-tablesheet";
import '@grapecity/spread-sheets-designer-resources-en';
import '@grapecity/spread-sheets-designer'
import '@grapecity/spread-sheets/styles/gc.spread.sheets.excel2016colorful.css';
import "@grapecity/spread-sheets-designer/styles/gc.spread.sheets.designer.min.css";
import * as Sentry from '@sentry/vue';
// Khai báo sử dụng pinia
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';
import { createPinia } from 'pinia';
const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);
app.use(pinia);

// import 'vue-toast-notification/dist/theme-sugar.css';

// Add extension
import './commons/prototype';
// Globally Registered Components
import { useComponents } from '@/commons/globalComponents.js';
useComponents(app);

// phím tắt
import { shortKey } from '@/commons/directives/shortkey.js';
app.directive('shortkey', shortKey);

// Globally Registered Components
import { pluginInstall } from '@/commons/globalPlugin.js';
pluginInstall(app);

// Đăng ký popup
import { register } from '@/commons/globalPopup.js';
register(app);

/** Vue tour step */
import vueTour from 'v3-tour';
app.use(vueTour);

// filter
import { initFilter } from './commons/msFormat';
initFilter(app);

// Styles: SCSS
import '@/assets/css/flexbox.css';
import '@/assets/css/common.css';
import '@/assets/scss/scroller.scss';
import '@/assets/scss/override.scss';
import '@/assets/scss/icons.scss';
import '@/assets/scss/btn.scss';
import '@/assets/scss/form.scss';
import '@/assets/scss/app.scss';
import '@/assets/scss/main-style.scss';
import '@/assets/scss/workbook.scss';

let hostname = import.meta.env?.VITE_HOST_NAME ?? 'bumasapp.misa.vn';
if (window.location.hostname == hostname) {
// Thêm đoạn sau 
  Sentry.init({
    app, // ‘app’ cho Vue3 hoặc ‘Vue’ cho Vue2
    dsn: import.meta.env.VITE_SENTRY_DSN,// Đưa dsn vào biến môi trường hoặc dán thẳng
    sendDefaultPii: true,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 1.0, 
    beforeSendTransaction(event) {

      const THRESHOLDS = {
        LCP: 2500,      
        CLS: 0.1,        
        INP: 200,        
        FCP: 1000,       
        TTFB: 300,       
        CLICK_DELAY: 200,
        API_TIMEOUT: 3000
      };


      const op = event?.contexts?.trace?.op;
      const measurements = event?.measurements || {};
      
      // Tính Duration (ms)
      const start = event.start_timestamp || 0;
      const end = event.timestamp || 0;
      const duration = (end - start) * 1000;


      // ---  Xử lý Pageload & Navigation (Web Vitals) ---
      if (op === 'pageload' || op === 'navigation') {
        // Lấy các chỉ số (nếu không có thì mặc định là 0)
        const lcp = measurements['lcp']?.value || 0;
        const cls = measurements['cls']?.value || 0;
        const inp = measurements['inp']?.value || 0;
        const fcp = measurements['fcp']?.value || 0;
        const ttfb = measurements['ttfb']?.value || 0;


        // Kiểm tra xem có chỉ số nào vượt ngưỡng không
        const isBadExperience =
          lcp > THRESHOLDS.LCP ||
          cls > THRESHOLDS.CLS ||
          inp > THRESHOLDS.INP ||
          fcp > THRESHOLDS.FCP ||  
          ttfb > THRESHOLDS.TTFB;  


        if (isBadExperience) {
          return event;
        }
        if (Math.random() < 0.01) {
          if (event.spans) {
            event.spans = event.spans.filter(span =>
              span.op === 'http.client' || span.op.startsWith('ui')
            );
          }
          return event;
        }
        return null;
      }
      // ---  Xử lý Tương tác (Click) ---
      if (op === 'ui.interaction.click' || op === 'ui.action') {
        if (duration > THRESHOLDS.CLICK_DELAY) {
          return event;
        }
        return null;
      }


      // ---  Xử lý API (Fetch/XHR) ---
      if (op === 'http.client') {
        const status = event.contexts?.response?.status_code;
        if ((status && status >= 400) || duration > THRESHOLDS.API_TIMEOUT) {
          return event;
        }
        return null;
      }
      return null;
    },

  });
}
//
// import '../node_modules/@syncfusion/ej2-base/styles/material.css';
// import '../node_modules/@syncfusion/ej2-buttons/styles/material.css';
// import '../node_modules/@syncfusion/ej2-calendars/styles/material.css';
// import '../node_modules/@syncfusion/ej2-dropdowns/styles/material.css';
// import '../node_modules/@syncfusion/ej2-inputs/styles/material.css';
// import '../node_modules/@syncfusion/ej2-navigations/styles/material.css';
// import '../node_modules/@syncfusion/ej2-popups/styles/material.css';
// import '../node_modules/@syncfusion/ej2-splitbuttons/styles/material.css';
// import '../node_modules/@syncfusion/ej2-vue-grids/styles/material.css';
// import '../node_modules/@syncfusion/ej2-vue-treegrid/styles/material.css';

app.config.productionTip = false;

// Vue.config.errorHandler = log.handleGlobalException;
// eslint-disable-next-line no-undef
if (process.env.NODE_ENV == 'development') {
  app.config.performance = true;
}

/**
 * directive xử lý style.visibility
 */
app.directive('visible', function (el, binding) {
  el.style.visibility = binding.value ? 'visible' : 'hidden';
});

// Khai báo router
import router from '@/routers/router';
app.use(router);



// Sử dụng localize
import i18n from '@/i18ns/i18n';
app.use(i18n);

import { PromiseDialog } from 'vue3-promise-dialog';
app.use(PromiseDialog);

// import {registerLicense} from '@syncfusion/ej2-base';

// // Registering Syncfusion license key
// registerLicense('ORg4AjUWIQA/Gnt2UVhhQlVFfV1dVHxLflFyVWJZdVp4flBBcDwsT3RfQFljSH9TdEdnUH1WdHJWRQ==');

app.mount('#app');
